import * as Sentry from '@sentry/browser';
import hydrate from './hydrate';

const dsn = process.env.SENTRY_DSN;
if (dsn) {
	Sentry.init({
		dsn,
		environment: process.env.NODE_ENV || 'development',
		allowUrls: [/https?:\/\/((www)\.)?stutterheim\.com/],
		ignoreErrors: ['Non-Error promise rejection captured'],
	});
}

hydrate();
